import React, { useEffect, useState } from "react";

import { WizardForm, FormVariant } from "@comparaonline/car-dealer-chile";
import { CarDealerForm as CarDealerFormValues } from "@comparaonline/contact-form-schema";

import { redirectToQuote, redirectToSuccess, saveInFirestore } from "../helpers";
import { NotFoundError } from "../../../utils/error";
import { getCarDealers } from "../../../api/carDealers";
const onSubmit = (values: CarDealerFormValues) => {
  if (Boolean(values.email)) {
    return saveInFirestore(values).then(() => redirectToSuccess(values.carDealerData.name));
  }
  return redirectToQuote(values.carDealerData);
};

const getFormVariant = async (carDealerName: string, variant?: FormVariant) => {
  const carDealers = await getCarDealers();
  const carDealer = carDealers.find(item => item.slug === carDealerName.toLowerCase());
  if (!carDealer) return;
  if (variant === undefined) return carDealer.variant[0];
  return carDealer.variant.find(item => item === variant);
};

interface CarDealerFormProps {
  carDealerName: string;
  massive: boolean;
  carDealerAgentId?: string;
  variant?: FormVariant;
}

const CarDealerForm: React.FC<CarDealerFormProps> = ({
  carDealerName,
  carDealerAgentId = "",
  massive,
  variant
}) => {
  const [formVariant, setFormVariant] = useState();

  useEffect(() => {
    getFormVariant(carDealerName, variant).then(variant => {
      if (variant === undefined) {
        throw new NotFoundError();
      }
      setFormVariant(variant);
    });
  }, []);

  if (formVariant === undefined) {
    return null;
  }

  return (
    <WizardForm
      handleSubmit={onSubmit}
      values={{
        carDealerData: {
          name: carDealerName,
          agentIdentificationNumber: carDealerAgentId,
          massive
        }
      }}
      variant={formVariant}
    />
  );
};

export { CarDealerForm };
